var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBytesizeUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7491 27.5C0.499069 28.75 1.74907 15 11.7491 16.25C7.99907 2.49996 29.2491 2.49996 27.9991 12.5C40.4991 8.74996 40.4991 28.75 29.2491 27.5M14.2491 22.5L20.4991 17.5M20.4991 17.5L26.7491 22.5M20.4991 17.5V36.25",
    stroke: "#484848",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBytesizeUpload);
export default __webpack_public_path__ + "static/media/bytesize_upload.4e1ac0b7ded88cbe34e2f8e58f1acc64.svg";
export { ForwardRef as ReactComponent };